<template>
    <div>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search...(case-sensitive)"
                    >
                    </base-input>
                    <!-- <base-input label="Filter by Hub Manager" class="mx-4">
                        <el-select
                            v-model="filterManager"
                            multiple
                            placeholder="Select Manager"
                            >
                            <el-option
                                v-for="item in hubManagers"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </base-input> -->
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table
                ref="multipleTable"
                :data="queriedData"
                style="width: 100%"
                empty-text="No Data"
                @selection-change="selectionChange"
                v-loading="isTableLoading"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    
                ></el-table-column>

                <!-- COLUMN NAME/ID -->
                <el-table-column
                    label="Name/ID"
                    prop="lead_name"
                    min-width="200"
                    sortable
                >
                    <template slot-scope="scope">
                        <router-link :to="'#'" class="name font-weight-500 mb-0">
                            {{ scope.row.lead_name }}
                        </router-link><br>
                         <p class="mb-0 bottom-line">{{ scope.row.lead_id }}</p>
                    </template>
                </el-table-column>

                <!-- COLUMN TITLE -->
                <el-table-column
                    label="Title/Description"
                    prop="subject"
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.subject }}</p>
                        <p class="mb-0 bottom-line">{{ scope.row.description }}</p>
                    </template>
                </el-table-column>

                <!-- COLUMN SCHEDULED DATETIME -->
                <el-table-column
                    label="Scheduled Date/Time"
                    prop="start_at"
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.start_at | dateFormatString  }} ({{ getDay(scope.row.start_at) }})</p>
                        <!-- <p class="mb-0 bottom-line">{{ dateToTime(scope.row.start_at) }}</p> -->
                        <p class="mb-0 bottom-line">{{ scope.row.start_at |timeFormatString }}</p>
                    </template>
                </el-table-column>

                <!-- COLUMN LOCATION -->
                <el-table-column
                    label="Location"
                    prop="location"
                    min-width="200"
                    sortable
                ></el-table-column>

                <!-- COLUMN LOCATION TYPE -->
                <el-table-column
                    label="Location type/Duration"
                    prop="type"
                    min-width="200"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.type }}</p>
                        <p class="mb-0 bottom-line">{{ scope.row.duration }}</p>
                    </template>
                </el-table-column>

                <!-- COLUMN ASSIGN TO -->
                <el-table-column
                    label="Assign to/Hub(Team)"
                    prop="user_name"
                    min-width="200"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.username }}</p>
                        <span class="mb-0 bottom-line">{{ scope.row.hub_name }} </span>
                        <span class="mb-0 bottom-line">({{ scope.row.team_name }})</span>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed="right"
                >
                    <el-button type="text">
                        <b-icon icon="three-dots-vertical"></b-icon>
                    </el-button>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer">
            <div
                class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
            >
                <div class="d-flex align-items-center mb-3">
                    <p class="card-category mb-0 text-secondary">
                        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            
                        <span v-if="selectedRows.length">
                            &nbsp; &nbsp; {{selectedRows.length}} rows selected
                        </span>
                    </p>

                    <span class="mb-0 ml-4">Rows:</span>

                    <el-select
                        class="select-primary pagination-select mx-2"
                        v-model="pagination.perPage"
                        placeholder="Per page"
                    >
                        <el-option
                            class="select-primary"
                            v-for="item in pagination.perPageOptions"
                            :key="item"
                            :label="item"
                            :value="item"
                        >
                        </el-option>
                    </el-select>
        
                </div>
                <base-pagination
                    class="pagination-no-border"
                    :current="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    @change="paginationChanged($event)"
                >
                </base-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Button } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { axios, services, getHeader, debounce } from '@/assets/js/httpImports.js'
import { format } from 'd3'
import { EventBus } from '@/main'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['lead_name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: [
                {
                    id: 1002,
                    name: 'Carine Tam',
                    title: 'Follow Up #2',
                    description: 'Lorem ipsum veitys morit teltca',
                    schedule_date: '23 Nov 2023 (Thu)',
                    schedule_time: '12.00pm',
                    location: 'Abc Cafe',
                    type: 'online',
                    duration: '60 mins',
                    assigned_to: 'Alexandrina',
                    hub_name: 'Hub Skypod',
                    team_name: 'Team C'
                },
                {
                    id: 1002,
                    name: 'Carine Tam',
                    title: 'Follow Up #2',
                    description: 'Lorem ipsum veitys morit teltca',
                    schedule_date: '23 Nov 2023 (Thu)',
                    schedule_time: '12.00pm',
                    location: 'Abc Cafe',
                    type: 'online',
                    duration: '60 mins',
                    assigned_to: 'Alexandrina',
                    hub_name: 'Hub Skypod',
                    team_name: 'Team C'
                },
            ],
        }
    },
    created(){
        this.getMeeting()
        EventBus.$on('refreshmeeting', (data) => {
            this.getMeeting()
        });
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
        EventBus.$on('getnewmeeting', (data) => {
            this.getNewMeeting(data)
        });
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getMeeting(){
            this.isTableLoading = true
            axios.get(services.lead + 'meeting', {headers: getHeader()})
                .then(res => {
                    this.isTableLoading = false
                    this.tableData = res.data.data
                })
                .catch(e => {
                    this.isTableLoading = false
                    this.errorFunction(e)
                })
        },
        getNewMeeting(data){
            this.tableData.push(data)
        },
        getDay(date){
            const thedate = new Date(date)
            const day = thedate.toLocaleString('en-US', { weekday: 'short' });
            return day;
        }
        // dateToTime(dateTime){
        //     const newdateTime = new Date(dateTime);
        //     return newdateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        // }
    }
}
</script>